import { ColorAPI } from '@/clients/product/color.api'
export default {
    namespaced: true,
    state: {
        addPop: false,
        editPop: false,
        editObj: {},
        list: []
    },
    getters: {
        addPop: state => state.addPop,
        editPop: state => state.editPop,
        editObj: state => state.editObj,
        list: state => state.list
    },
    mutations: {
        mutateAddPop(state, data) {
            state.addPop = data
            // If add is on edit is false
            state.editPop = false
        },
        mutateEditPop(state, data) {
            state.editPop = data
            // If Edit is on add is false
            state.addPop = false
        },
        mutateEditObj(state, data) {
            state.editObj = data
        },
        mutateList(state, data) {
            state.list = data
        },
        clearColorState(state) {
            Object.assign(state, require('./reset/color.json'))
        }
    },
    actions: {
        setAddPop(context, data) {
            context.commit('mutateAddPop', data)
        },
        setEditPop(context, data) {
            context.commit('mutateEditPop', data)
        },
        setEditObj(context, data) {
            context.commit('mutateEditObj', data)
        },
        async setList(context) {
            const { data: { payload } } = await ColorAPI.list()
            context.commit('mutateList', payload)
        }
    }
}
